import { createApp } from "vue";

import { Amplify } from "aws-amplify";

import VueHtml2Canvas from "vue-html2canvas";

import moment from "moment-timezone";
import { Chart, registerables } from "chart.js";
import { vuetify } from "./plugins/vuetify";
import App from "./App.vue";
import { router } from "./router";
import { store } from "./store/store";
import { newCommonFormatCurrency } from "../../backend/src/common/services/mathServices";
import { i18n } from "./i18n";
import "../node_modules/nprogress/nprogress.css";
import getEnv from "./env";

import * as Sentry from "@sentry/vue";
import { apolloProvider } from "./apollo.services";
import BoxComponent from "./views/designer/BoxComponent.vue";
import Chat from "./views/chat/Chat.vue";

import sanitizer from "./services/sanitizerServices";

const env = getEnv();
export const app = createApp(App);

Amplify.configure(env.AMPLIFY_CONFIG);
moment.locale("fr");
Chart.register(...registerables);

app.use(apolloProvider);
app.use(store);
app.use(VueHtml2Canvas);
app.use(i18n);
app.use(router);
app.use(vuetify);

app.use(sanitizer);

app.component("BoxComponent", BoxComponent);

app.component("Chat", Chat);

app.config.globalProperties.constructor = () => {};
app.config.globalProperties._isVue = true;

app.mixin({
    methods: {
        newCommonFormatCurrency,
    },
});

Sentry.init({
    app,
    dsn: "https://c561a13b606245f88896c3a06d7b50fa@o4505034625449984.ingest.us.sentry.io/4505034634756096",
    environment: env.environnement,
    beforeSend: (event /*, hint*/) => {
        // const paths = window.location.pathname.split("/")
        const components = router.currentRoute.value.matched
            .flatMap((record) => Object.values(record.components))
            .map((c) => c["name"])
            .join(" - ");
        const routeName = router.resolve({ path: window.location.pathname }).name.toString();
        event.fingerprint = [routeName];
        event.tags = {
            ...event.tags,
            "router.path": window.location.pathname,
            "router.components": components,
            "router.routeName": routeName,
        };
        return event;
    },
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({ levels: ["error"] }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
        "localhost",
        "127.0.0.1",
        /^https:\/\/staging-app\.bobbee\.co/,
        /^https:\/\/app\.bobbee\.co/,
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    trackComponents: true,
});

Sentry.setUser({
    userId: store.state?.user?.id || "User id is not set",
    email: store.state?.user?.email || "Email is not set",
});

Sentry.setContext("Company info", {
    companyId: store.state?.selected_company?.id || "Selected company id is not set",
    accountingPeriodId:
        store.state?.accountingPeriod?.selectedAccountingPeriod?.id ||
        "Selected accounting period id is not set",
    accountingFirmId: store.state?.companyAccountingFirm?.id || "Accounting firm is not set",
});

app.mount("#app");

if (window["Cypress"]) {
    // Add `store` to the window object only when testing with Cypress
    window["store"] = store;
    window["app"] = app;
    store.commit("updateTest", true);
}
